<template>
  <el-dialog
      v-el-drag-dialog
      class="adaptationModal"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : procedure.pkid ? '编辑' : '新建'"
      width="800px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="procedure"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div>
        <div class="editTitle">基本信息</div>
        <el-row>
          <el-col v-if="procedure.pkid" :span="12">
            <el-form-item label="工序编号">
              <el-input v-model="procedure.processNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序类型" prop="processType">
              <el-select v-model="procedure.processType" placeholder="请选择工序类型" clearable>
                <el-option v-for="item in processTypeList" :key="item.pkid" :label="item.processTypeName" :value="item.pkid"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序名称" prop="processName" clearable>
              <el-input v-model="procedure.processName" placeholder="请输入工序名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序状态" prop="status">
              <el-select v-model="procedure.status" placeholder="请选择工序状态" clearable>
                <el-option label="未确认" :value="0"/>
                <el-option label="已确认" :value="1"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input 
                  v-model="procedure.note" 
                  type="textarea" 
                  autosize 
                  clearable 
                  placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div>
        <div class="editTitle">工作单元</div>
        <el-button type="primary" style="margin-bottom: 8px" @click="$refs.workUnitSelect.open()"> 添加 </el-button>
        <el-table
            border
            stripe
            :data="procedure.processWorkUnits">
          <el-table-column label="工作单元名称" prop="workUnitName" align="center" width="150"/>
          <el-table-column label="工作单元编号" prop="workUnitNo" align="center"/>
          <el-table-column label="所属工作中心" prop="workCenterName" align="center"/>
          <el-table-column label="是否默认" align="center">
            <template v-slot="scope">
              <el-radio-group v-model="scope.row.isDefault" @input="isDefaultChange(scope.row,scope.$index)">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="editTitle">关键技能</div>
        <el-button type="primary" style="margin-bottom: 8px" @click="$refs.selectSkill.open()"> 添加 </el-button>
        <el-table :data="procedure.processSkills" border>
          <el-table-column prop="skillNo" align="center" label="技能编号" width="100"/>
          <el-table-column prop="skillName" align="left" label="技能名称"/>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteSkill(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="editTitle" style="margin-top: 8px">ESOP</div>
        <el-button type="primary" style="margin-bottom: 5px" @click="$refs.selectEsop.open()"> 添加 </el-button>
        <el-table :data="procedure.processEsops" class="esopTable" border>
          <el-table-column prop="esopNo" align="center" label="ESOP编号" width="100"/>
          <el-table-column prop="esopName" align="left" label="ESOP名称"/>
          <el-table-column prop="esopPageNo" align="center" label="页码" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.esopPageNo" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteEsop(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <!-- 选择关键技能 -->
    <work-unit-select ref="workUnitSelect" @select="workUnitSelect"/>
    <skill-select ref="selectSkill" @select="selectSkill"/>
    <esop-select ref="selectEsop" @select="selectEsop"/>
  </el-dialog>
</template>

<script>
  import WorkUnitSelect from "@/views/information/WorkUnit/WorkUnitSelect";
  import SkillSelect from "@/views/information/Skill/SkillSelect";
  import EsopSelect from "@/views/information/Esop/EsopSelect";
  export default {
    components: {
      SkillSelect,
      EsopSelect,
      WorkUnitSelect,
    },
    props: {
      processTypeList: {
        type: Array,
        default: () => [],
      },
    },
    
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        procedure: {
          pkid: 0,
          processName: "",
          processType: "",
          note: "",
          status: "",
          processSkills: [],
          processEsops: [],
          processWorkUnits:[],
          processNo: "",
          esopId: "",
          esopPageNo: "",
        },
        ruleValidate: {
          processType: { required: true, message: "请选择工序类型", trigger: "change" },
          processName: { required: true, message: "请输入工序名称", trigger: "blur" },
          status: { required: true, message: "请选择工序状态", trigger: "change" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        if (row) {
          this.getData(row.pkid);
        }
      },

      selectSkill(row) {
        const arr = this.procedure.processSkills.filter((item) => item.skillNo === row.skillNo);
        if (arr.length) {
          this.$confirm("技能：" + row.skillName + "已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const skillItem = {
          skillId: row.pkid,
          skillNo: row.skillNo,
          skillName: row.skillName,
        };
        this.procedure.processSkills.push(skillItem);
      },

      deleteSkill(index) {
        this.procedure.processSkills.splice(index, 1);
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `rtProcess/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.procedure = Object.assign(this.procedure, resp.data);
              if (resp.data.esopId) {
                const espoItem = {
                  esopNo: resp.data.esopNo,
                  esopName: resp.data.esopName,
                  esopPageNo: resp.data.esopPageNo,
                };
                this.procedure.processEsops.push(espoItem);
              }
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择ESOP
      selectEsop(row) {
        const esopItem = {
          esopId: row.pkId,
          esopNo: row.esopNo,
          esopName: row.esopName,
          esopPageNo: 1,
        };
        this.$set(this.procedure.processEsops, 0, esopItem);
      },

      // 删除ESOP
      deleteEsop(index) {
        this.procedure.processEsops.splice(index, 1);
        this.procedure.esopId = 0;
      },

      //添加工作单元
      workUnitSelect(row) {
        console.log(row);
        let arr = this.procedure.processWorkUnits.filter(item => item.workUnitId === row.pkId);
        if(arr.length) {
          this.$message.error("请勿重复添加工作单元");
        }else{
          row.workUnitId = row.pkId;
          this.procedure.processWorkUnits.push(row);
        }
      },

      deleteRow(index) {
        this.procedure.processWorkUnits.splice(index,1);
      },

      isDefaultChange(row,index) {
        console.log(row);
        if (row.isDefault) {
          this.procedure.processWorkUnits.forEach((item) => {
            if(row.workUnitId === item.workUnitId) {
              this.$set(this.procedure.processWorkUnits,row,index);
            }else {
              item.isDefault = false;
            }
          });
        }else {
          this.procedure.processWorkUnits.forEach((item) => {
            if(row.workUnitId === item.workUnitId) {
              item.isDefault = false;
            }
          });
        }
        console.log(this.procedure.processWorkUnits);
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            if (this.procedure.processEsops.length) {
              this.procedure.esopId = this.procedure.processEsops[0].esopId;
              this.procedure.esopPageNo = this.procedure.processEsops[0].esopPageNo;
            }
            this.$http
              .save("basic", "rtProcess", this.procedure)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  if (this.procedure.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>

<style lang="scss">
.esopTable .el-input--mini .el-input__inner {
  text-align: center !important;
}
</style>
